import React from "react";
import styled from "styled-components";
import { Row, Col } from "reactstrap";
import { RebelColors, RebelTitle, RebelSubtitle } from "../../../styles/rebel-experiences";
import RebelExperienceGuideList from "./rebel-experiences-list"

const RebelExperiences = (props) => {
    return(
        <PageContainer>
            <Row>
                <Col style={{textAlign: "center"}}>
                    <RebelTitle>
                        R.E.B.E.L Experiences
                    </RebelTitle>
                    <RebelSubtitle>
                        Refined Elite Business & Executive Leisure
                    </RebelSubtitle>
                </Col>
            </Row>
            <RebelExperienceGuideList client={props.client}/>
        </PageContainer>
    )
}

export default RebelExperiences;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;